const rodillerasRig = [

  // INZER ERGO PRO
  {
    id: "inzer-ergo-pro",
    slug: "rodilleras-inzer-ergo-pro",
    name: "Inzer Ergo Pro",
    sizeGuide: "/Guias/sg-ergopro.png",
    category: "rodilleras-rigidas",
    brand: "INZER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL"],
    bestSeller: true,
    variants: [
      { color: "Negro", image: "/Productos/rodis-inzer.webp", price: 219, oldPrice: 245},
      { color: "Azul", image: "/Productos/inz-azu.webp", price: 219, oldPrice: 245 },
      { color: "Rojo", image: "/Productos/inz-roj.webp", price: 219, oldPrice: 245 },
      { color: "Blanco", image: "/Productos/inz-bla.jpg", price: 219, oldPrice: 245 },
    ],
  },

  // A7 RIGOR MORTIS
  {
    id: "a7-rigor-mortis",
    slug: "rodilleras-a7-rigor-mortis",
    name: "A7 Rigor Mortis",
    category: "rodilleras-rigidas",
    brand: "A7",
    sizeGuide: "/Guias/sg-rodis-rigor.png",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL"],
    variants: [
      { color: "Shadow Stone", images: ["/Productos/rodis-a7.webp","/Productos/a7-rm-shst-2.webp","/Productos/a7-rm-shst-3.webp"], price: 247.5 },
      { color: "Stealth", images: ["/Productos/rodis-a7-stealth.webp","/Productos/a7-stiff-sth-2.webp","/Productos/a7-rm-sth-2.webp"], price: 247.5 },
      { color: "Gold Standard", images: ["/Productos/rodis-a7-gs.webp","/Productos/a7-rm-gs-2.webp"], price: 247.5 },
      { color: "Red Dawn", images: ["/Productos/rodis-a7-red.webp","/Productos/a7-rm-rd-2.webp"], price: 247.5 },
      { color: "Tides", images: ["/Productos/a7-rm-tides.webp","/Productos/a7-rm-tides-2.jpg"], price: 247.5 },
      { color: "Dusk", images: ["/Productos/a7-rm-dusk.webp","/Productos/a7-rm-dusk-2.webp  "], price: 247.5 },
      { color: "Aurora", images: ["/Productos/rodis-a7-rm-aur.webp","/Productos/rodis-a7-rm-aur-2.webp  "], price: 247.5 },
      { color: "Ivory Rose", images: ["/Productos/rodis-a7-ivo.webp","/Productos/a7-rm-ivo-2.webp"], price: 247.5 },
      { color: "Polar", images: ["/Productos/rodis-a7-po.webp","/Productos/a7-rm-po-2.webp"], price: 247.5 },
      { color: "Emerald", images: ["/Productos/rodis-a7-esm.webp","/Productos/a7-rm-eme-2.webp"], price: 247.5 },
      { color: "Night Light", images: ["/Productos/a7-rm-nl.webp","/Productos/a7-rm-nl-2.webp"], price: 247.5 },
      { color: "Violet Tiger", images: ["/Productos/rodis-a7-vio.webp","/Productos/a7-rm-vio-2.webp"], price: 247.5 },
      { color: "Pink", images: ["/Productos/rodis-a7-pink.webp","/Productos/a7-rm-pink-2.webp"], price: 247.5 },
    ],
  },

  // TITAN TKS
  {
    id: "titan-tks",
    slug: "rodilleras-titan-tks",
    category: "rodilleras-rigidas",
    name: "Titan TKS",
    sizeGuide: "/Guias/sg-tks.png",
    brand: "TITAN",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL"],
    variants: [
      { image: "/Productos/rodis-titan-tks.png", price: 238 }
    ],
  },
  {
    id: "pioneer-knee-sleeves",
    slug: "rodilleras-pioneer",
    category: "rodilleras-rigidas",
    sizeGuide: "/Guias/sg-rodis-pioneer.png",
    name: "Rodilleras Pioneer",
    brand: "PIONEER",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL"],
    variants: [
      { image: "/Productos/rodis-pio.jpg", price: 195 }
    ],
  },
  
  {
    id: "strenghtshop-inferno-pro",
    category: "rodilleras-rigidas",
    slug: "rodilleras-strenghtshop-inferno-pro",
    name: "Rodilleras Inferno Pro 7mm",
    brand: "IRON REBEL",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { image: "/Productos/rodis-strsh.webp", price: 200 }
    ],
  },


  // IRON REBEL
  {
    id: "iron-rebel-contour",
    category: "rodilleras-rigidas",
    slug: "rodilleras-iron-rebel-contour-pr",
    name: "Iron Rebel Contour PR",
    sizeGuide: "/Guias/sg-rodis-iron.png",
    brand: "IRON REBEL",
    sizes: ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { image: "/Productos/iron-rebel.con.webp", price: 220 }
    ],
  },

];

export default rodillerasRig;
